import { selectRouterPathname } from '@noths/polaris-client-next-redux';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { push, replace } from 'connected-next-router';

import { buildShopListingFullUrl } from 'src/adapters/pageURLToStore/shop/serializeShopListingPath';
import {
  adaptStoreToFilterPath,
  adaptStoreToPageURL,
} from 'src/adapters/storeToPageURL/adaptStoreToPageURL';
import { buildListingsURL } from 'src/adapters/storeToPageURL/buildListingsURL';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { PageType } from 'src/types/navigation';

interface UpdatePageURLWithQueryOptions {
  history?: 'push' | 'replace';
}

export const updatePageURLWithQuery = createAsyncThunk<void, UpdatePageURLWithQueryOptions | void>(
  'products/updatePageURLWithQuery',
  async (options, { dispatch, getState }) => {
    const { history = 'push' } = options ?? {};
    const state = getState() as ReduxApplicationState;
    const { pathname } = state.router.location;
    const routerPathname = selectRouterPathname(state);
    const { page } = state.productsQuery;

    if (state.navigation.pageType === PageType.Shop) {
      const url = buildShopListingFullUrl(state);
      dispatch((history === 'push' ? push : replace)(url, url, { shallow: true, scroll: false }));
      return;
    }

    const urlParams = adaptStoreToPageURL(state, page);
    const filterPath = adaptStoreToFilterPath(state);
    const href = buildListingsURL(routerPathname, filterPath, urlParams, state.navigation.hash);
    const as = buildListingsURL(pathname, filterPath, urlParams, state.navigation.hash);

    dispatch((history === 'push' ? push : replace)(href, as, { shallow: true, scroll: false }));
  },
);
